import { ControlConstants } from "../../control/constant/ControlConstants";
import { ButtonProperties } from "../../control/properties/ButtonProperties";
import { DialogProperties } from "../../control/properties/DialogProperties";
import { SpriteProperties } from "../../control/properties/SpriteProperties";
import { TextFieldProperties } from "../../control/properties/TextFieldProperties";
import { MessageDialog } from "../display/MessageDialog";
import { CommonFontStyle } from "../style/CommonFontStyle";
import { CommonStyle } from "../style/CommonStyle";
/**
 * AbstractMessageDialogProperties.ts
 */
export class AbstractMessageDialogProperties extends DialogProperties {
    equals(other) {
        return super.equals(other) &&
            this.backgroundProperties.equals(other.backgroundProperties) &&
            this.confirmButtonProperties.equals(other.confirmButtonProperties) &&
            this.titleFieldProperties.equals(other.titleFieldProperties) &&
            this.messageFieldProperties.equals(other.messageFieldProperties);
    }
    setDefaultValues() {
        super.setDefaultValues();
        this.backgroundProperties = new SpriteProperties(CommonStyle.MESSAGE_DIALOG_0, CommonStyle.MODULE);
        this.confirmButtonProperties = new ButtonProperties(CommonStyle.DIALOG_BUTTON_0, CommonStyle.MODULE);
        this.confirmButtonProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.DIALOG_BUTTON_0);
        this.titleFieldProperties = new TextFieldProperties(CommonFontStyle.DIALOG_TITLE, null, null, ControlConstants.CENTER, ControlConstants.CENTER);
        this.messageFieldProperties = new TextFieldProperties(CommonFontStyle.DIALOG_MESSAGE, null, null, ControlConstants.CENTER, ControlConstants.CENTER);
        this.messageFieldProperties.multiline = true;
        this.messageFieldProperties.verticalAlign = ControlConstants.CENTER;
    }
    getClass() {
        return MessageDialog;
    }
    getClassName() {
        return "MessageDialog";
    }
}
//# sourceMappingURL=AbstractMessageDialogProperties.js.map